import { Moment } from 'moment';
import { Week } from './../weeks/types';
import { Image } from '../shared/types';
// import { Image } from './../shared/types';

export interface Season {
  id: number;
  title: string;
  image: Image;
  selected: boolean;
  weeks: Week[];
  startdate: Date;
  enddate: Date;
  sectionTitle: string;
}

export interface SeasonCreate {
  title: string;
  sectionTitle: string;
  startdate: Moment;
  enddate: Moment;
}

export const enum SeasonActionTypes {
  FETCH_REQUEST = '[season]FETCH_REQUEST',
  FETCH_SUCCESS = '[season]FETCH_SUCCESS',
  FETCH_ERROR = '[season]FETCH_ERROR',

  UPDATE_SUCCESS = '[season]UPDATE_SUCCESS',

  CREATE_SUCCESS = '[season]CREATE_SUCCESS',

  DELETE_SUCCESS = '[season]DELETE_SUCCESS',

  CHECK_CURRENT_SEASON = '[season]CHECK_CURRENT_SEASON',
  TOGGLE_SEASON = '[season]TOGGLE_SEASON'
}

export interface ISeasonData {
  byId: { [id: number]: Season };
  allIds: number[];
  bySectionTitle: { [id: string]: number[] };
}

export interface SeasonState {
  readonly loading: boolean;
  readonly data: ISeasonData;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/season/types.ts